const gellary = [
  "./images/g_1.jpg",
  "./images/g_2.jpg",
  "./images/g_3.jpg",
  "./images/g_4.jpg",
];
export default gellary;
